import styled from 'styled-components';

import { grey10 } from 'approot/shared/styles/colours.style';

export const RichtextReadonlyPlaceholder = styled.span`
  color: ${grey10};
`;
